module.exports = __webpack_public_path__ + "static/media/plus.15802394.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/plus.svg
// module id = 1407
// module chunks = 0